import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { WolAuthInfo } from "../../app/types";

const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/oauth/" }),
  endpoints: (builder) => ({
    getInitialAuth: builder.mutation<WolAuthInfo, void>({
      query: () => ({
        url: "token",
        method: "post",
        body: {
          grant_type: "cookie",
          client_id: "user",
        },
      }),
    }),
    getRefreshTokenAuth: builder.mutation<WolAuthInfo, string>({
      query: (refresh_token) => ({
        url: "token",
        method: "post",
        body: {
          grant_type: "refresh_token",
          client_id: "user",
          refresh_token,
        },
      }),
    }),
  }),
});

export const { useGetInitialAuthMutation, useGetRefreshTokenAuthMutation } =
  authApi;

export default authApi;
